export const RECORD_TYPES = {
  ITEM: 'item',
  PERSON: 'person',
  VEHICLE: 'vehicle',
}
